import * as net from 'util/Net';

export function setClientLastActive(
  secondsSinceLastActive: number
): Promise<{secondsUntilTimeout: number | null}> {
  return net.patchJSONPromise({
    url: '/1/api/session:keep-alive',
    data: {secondsSinceLastActive},
  });
}
